import { render, staticRenderFns } from "./Annotation.vue?vue&type=template&id=0131622d&scoped=true"
import script from "./Annotation.vue?vue&type=script&lang=js"
export * from "./Annotation.vue?vue&type=script&lang=js"
import style0 from "./Annotation.vue?vue&type=style&index=0&id=0131622d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131622d",
  null
  
)

export default component.exports